export default __webpack_public_path__ + "static/media/admin-console-v1-banner.bc336bb1.png";